export default __webpack_public_path__ + "static/media/THE-MACHAN-LONAVALA.f64d9220.jpg";